<div class="lum-modal" *ngIf="featureBOMAssemblyOrdersEnabled">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >Attach Bill of Materials</span
    >
  </div>

  <div class="lum-modal__body">
    <div class="bom-form__wrapper">
      <div class="bill-of-materials-form_wrapper">
        <mat-form-field class="w-100" appearance="outline">
          <mat-chip-list #chipList aria-label="Bom selection">
            <mat-chip *ngFor="let bom of selectedBoms; trackBy: trackByValue">
              <div class="chip-list-label">
                {{ bom?.name }}
              </div>
              <button matChipRemove (click)="onRemove(bom)">
                <lum-ui-icon
                  icon="close-circle"
                  [width]="18"
                  [height]="18"
                  color="#000000"
                ></lum-ui-icon>
              </button>
            </mat-chip>
            <input
              [matChipInputFor]="chipList"
              (input)="onSearchKeywordChange(autocompleteInput.value)"
              [matAutocomplete]="auto"
              #autocompleteInput
            />
          </mat-chip-list>
          <mat-autocomplete
            panelWidth="auto"
            #auto="matAutocomplete"
            (optionSelected)="onSelectOption($event)"
          >
            <ng-container *ngIf="!(loading$ | async) || false; else loader">
              <mat-option
                *ngFor="let bom of uniqueBoms; trackBy: trackByValue"
                [value]="bom"
              >
                {{ bom?.name }}
              </mat-option>
            </ng-container>
            <ng-template #loader>
              <div class="flex gap-4">
                <mat-progress-spinner
                  class="progress-spinner mt-3"
                  diameter="24"
                  mode="indeterminate"
                ></mat-progress-spinner>
                <small>Loading...</small>
              </div>
            </ng-template>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="lum-invoice-line-items__action flex mt-4 w-p100">
      <div class="flex ml-auto lum-modal__action">
        <button
          type="button"
          class="lum-button lum-button--secondary lum-button--large mx-1"
          (click)="dialogRef.close()"
        >
          Cancel
        </button>
        <button
          [disabled]="loading$ | async"
          type="button"
          class="lum-button lum-button--primary lum-button--large mx-1"
          (click)="onSubmit()"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</div>
